//import manager from '@/utils/manager'
import api from '@/utils/api'

export function accountInfo(params) {
    return api.get('wx/v1/account', { params:params })
}

export function getServerList(params) {
    return api.get('wx/v1/fkjlb/get_server', { params:params })
}

export function getRoleList(params) {
    return api.get('wx/v1/fkjlb/get_role', { params:params })
}
export function getGameId(params) {
    return api.get('wx/v1/fkjlb/get_game', { params:params })
}

export function payLianLian(params) {
    return api.post('lianLianPay/pay', params)
}

export function stripeMoneyList(params) {
    return api.post('stripe/moneyList', params)
}

//  mycard台湾支付
export function payMycard(params) {
    return api.post('mycardPay/pay', params)
}

//  微信支付
export function pay(params) {
    // return api.post('wx/v1/fenghuo/pay', params)
    params.project_id = 'fkjlb';
    params.type = 2;
    return api.post('wx/v1/official/common/wxpay', params)
}

export function commonCreateOrder(params) {
    return api.post('wx/v1/fkjlb/common/jzac', params)
}

//支付包支付或paypel支付
export function payMix(params) {
    // return api.post('wx/v1/fenghuo/pay/mix', params)
    return api.post('wx/v1/official_account/pay', params)
}

//公众号微信支付
export function payWxRedirect(orderNum) {
    //    最新版公众号微信支付
    return api.post('wx/v1/official/common/wxpay', { order_num: orderNum, type: 1, project_id: 'fkjlb' })
}
